import { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Loader from "../Common/Loader";
import {
  createPathyaAction,
  updatePathyaAction,
} from "../../../store/actions/PathyaActions";
import counsellorReducer from "../../../store/reducers/CounsellorReducer";

const AddPathyas = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { item } = location.state || {};
  const isEditMode = !!item;

  const [name, setName] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  const [existingPdf, setExistingPdf] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const getCleanFileName = (url = "") => {
    const file = url.split("/").pop();          // 1770706380_College id.pdf
    return file.replace(/^\d+_/, "");            // College id.pdf
  };


  useEffect(() => {
    if (isEditMode && item) {
      setName(item.pathya_name || "");
      setExistingPdf(item.pathya_file || "");
    }
  }, [isEditMode, item]);

  const validateForm = () => {
    const err = {};
    if (!name.trim()) err.name = "Pathya Name is required";
    if (!isEditMode && !pdfFile) err.pdf = "PDF is required";
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const clearFieldError = (field) => {
    setErrors((prev) => {
      if (!prev[field]) return prev;
      const { [field]: _removed, ...rest } = prev;
      return rest;
    });
  };

  const handleFieldChange = (field, value) => {
    if (field === "name") {
      setName(value);
    } else if (field === "pdf") {
      setPdfFile(value);
    }
    clearFieldError(field);
  };

  // ✅ CENTRALIZED FormData CREATION
  const buildFormData = () => {
    const data = {
      pathya_name: name.trim(),
      pathya_status: "Active",
      pathya_id: isEditMode ? item?.pathya_id : undefined,
    };

    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    if (pdfFile) {
      formData.append("pathya_file", pdfFile);
    }

    return formData;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    if (!validateForm()) return;
    const formData = buildFormData();

    try {
      setLoading(true);
      if (isEditMode) {
        await dispatch(updatePathyaAction(formData));
      } else {
        await dispatch(createPathyaAction(formData));
      }

      // ✅ NAVIGATE AFTER SUCCESS
      navigate("/pathyas");

    } catch (err) {
      console.error("UPLOAD ERROR:", err.response?.data || err);
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="d-flex justify-content-end mb-3">
          <Link to="/pathyas">
            <Button variant="primary">Back</Button>
          </Link>
        </div>

        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="mb-3">
                <label className="form-label">Pathya Name<span className="text-danger">*</span> </label>
                <input
                  type="text"
                  className="form-control"
                  value={name}
                  onChange={(e) => handleFieldChange("name", e.target.value)}
                />
                {errors.name && (
                  <div className="text-danger">{errors.name}</div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">
                  PDF <span className="text-danger">*</span>
                </label>
                {/* <input
                  type="file"
                  className="form-control"
                  accept=".pdf"
                  onChange={(e) => setPdfFile(e.target.files[0])}
                /> */}

                <input
                  type="file"
                  id="pdfInput"
                  hidden
                  accept=".pdf"
                  onChange={(e) => handleFieldChange("pdf", e.target.files[0])}
                />

                <input
                  type="text"
                  className="form-control"
                  readOnly
                  value={
                    pdfFile
                      ? pdfFile.name
                      : existingPdf
                        ? existingPdf.split("/").pop()
                        : ""
                  }
                  placeholder="Choose PDF"
                  onClick={() => document.getElementById("pdfInput").click()}
                />


                {isEditMode && existingPdf && (
                  <div className="mt-1">
                    <a
                      href={existingPdf}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary"
                      style={{ textDecoration: "underline" }}
                    >
                      Current file: {getCleanFileName(existingPdf)}
                    </a>
                  </div>
                )}

                {errors.pdf && (
                  <div className="text-danger">{errors.pdf}</div>
                )}
              </div>

              {errors.submit && (
                <div className="alert alert-danger">{errors.submit}</div>
              )}

              <button className="btn btn-primary" disabled={loading}>
                {loading ? (
                  <>
                    <Loader size="sm" /> Saving...
                  </>
                ) : isEditMode ? (
                  "Update Pathya"
                ) : (
                  "Add Pathya"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPathyas;
